// File: components/eventsSectionsComponents/EventsTestimonialsSection.jsx

import React from "react";
import "./EventsTestimonialsSection.css";

import testimonialImage1 from "../../Assets/images/trev.jpeg";
import testimonialImage2 from "../../Assets/images/rejoince.jpeg";
import testimonialImage3 from "../../Assets/images/benedicta2.jpeg";

export default function EventsTestimonialsSection() {

  const testimonials = [

    {
      image: testimonialImage1,

      quote:
        "The leadership retreat I attended with Ample House was an eye-opening experience that transformed my approach.",

      name: "Trevayne",

      role: "CEO"
    },

    {
      image: testimonialImage2,

      quote:
        "Ample House’s conference was not only inspiring but also filled with actionable insights for our business growth.",

      name: "Rejoice",

      role: "Manager"
    },

    {
      image: testimonialImage3,

      quote:
        "Our participation in Ample House’s expo showcased our thought leadership on a grand scale.",

      name: "Benedicta",

      role: "HR"
    }
  ];

  return (

    <section className="events-testimonials-section">

      <div className="events-testimonials-container">

        {/* Header */}
        <div className="events-testimonials-header">

          <span>
            Testimonials
          </span>

          <h2>
            Experiences That Inspire Leadership
          </h2>

        </div>

        {/* Testimonials Grid */}
        <div className="events-testimonials-grid">

          {testimonials.map((item, index) => (

            <div
              className="events-testimonial-card"
              key={index}
            >

              {/* Left Image */}
              <div className="events-testimonial-image-wrapper">

                <img
                  src={item.image}
                  alt={item.name}
                  className="events-testimonial-image"
                />

              </div>

              {/* Right Content */}
              <div className="events-testimonial-content">

                <div className="events-quote-mark">
                  “
                </div>

                <p className="events-testimonial-quote">
                  {item.quote}
                </p>

                <div className="events-testimonial-info">

                  <h4>
                    {item.name}
                  </h4>

                  <span>
                    {item.role}
                  </span>

                </div>

              </div>

            </div>

          ))}

        </div>

      </div>

    </section>

  );
}